<template>
    <div class="SalesTools">
        <v-navigation-drawer
            v-model="search.show"
            app
            temporary
            right
        >
            <v-card
                v-if="search.show"
                flat
            >
                <v-card-title>
                    Filtres<v-spacer/>
                    <v-btn
                        title="Appliquer"
                        right
                        small
                        fab
                        icon
                        @click.stop="runSearch"
                    >
                        <v-icon>mdi-check</v-icon>
                    </v-btn>

                    <v-btn
                        title="Effacer les filtres"
                        right
                        small
                        fab
                        icon
                        @click.stop="clearSearchTool"
                    >
                        <v-icon>mdi-cached</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-text-field 
                        v-model="search.text" 
                        autofocus
                        label="Rechercher" 
                        class="mx-4"
                        prepend-icon="mdi-magnify"
                    ></v-text-field>
                    
                    <v-select
                        v-if="Boolean(vendorsSelect.length)"
                        v-model="search.vendor"
                        :items="vendorsSelect"
                        label="Fournisseur"
                        prepend-icon="mdi-office-building"
                        class="mx-4"
                        clearable
                    />

                    <v-select
                        v-if="Boolean(categories.length)"
                        v-model="search.category"
                        :items="categories"
                        label="Catégorie"
                        prepend-icon="mdi-tag-text"
                        class="mx-4"
                        clearable
                    />
                </v-card-text>
            </v-card>
        </v-navigation-drawer>
        
        <v-speed-dial
            v-model="dial"
            fixed
            bottom
            right
            direction="top"
            transition="slide-y-reverse-transition"
        > 
            <template v-slot:activator>
                <v-btn
                    v-model="dial"
                    fab
                    dark
                    color="pink"
                >
                    <v-icon v-if="dial">mdi-close</v-icon>
                    <v-icon v-else>mdi-dots-horizontal</v-icon>
                </v-btn>
            </template>
            
            <v-btn 
                v-if="Boolean(selection.length)"
                fab
                dark
                small
                color="red darken-1"
                @click="del"
            >
                <v-icon>mdi-delete</v-icon>
            </v-btn>

            <v-btn 
                v-if="selection.length === 1"
                fab
                small
                color="deep-purple darken-4"
                dark
                @click="edit"
            >
                <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>

            <v-btn
                v-if="!Boolean(selection.length) || Boolean(deployed)"
                fab
                small
                color="success"
                @click="load"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn> 
            
            <v-btn
                v-if="!Boolean(selection.length)"
                fab
                dark
                small
                color="deep-purple darken-4"
                @click.stop="search.show = !search.show"
            >
                <v-icon dark>mdi-magnify</v-icon>
            </v-btn>  
        </v-speed-dial>

        <v-tabs 
            vertical
            @change="tabChange"
            color="deep-purple darken-4"
        >
            <v-tab class="justify-start">
                <v-icon left>mdi-file-multiple</v-icon>Opportunités
            </v-tab>
            
            <v-tab-item v-if="Boolean(collection)">
                <v-data-table
                    v-if="collection === 'opportunities'"
                    :headers="headers(collection)"
                    :items="tableData"
                    v-model="selection"
                    show-select
                    @item-selected="itemSelected"
                    :items-per-page="rpp"
                >
                    <template v-slot:item.author="{ item }">
                        <span v-if="Boolean(item.author)">{{ getUserRecord(item.author).displayName }}</span>
                    </template>

                    <template v-slot:item.calcs="{ item }">
                        <span>{{ Boolean(item.calcs) ? Object.keys(item.calcs).length : 0 }}</span>
                    </template>
                    
                    <template v-slot:item.lastUpdate="{ item }">
                        <span>{{ day(item.lastUpdate.time) }}, {{ time(item.lastUpdate.time) }}</span>
                    </template>
                </v-data-table>
            </v-tab-item>
        </v-tabs>

        <v-dialog 
            v-model="dialog"
            fullscreen 
            hide-overlay 
            transition="dialog-bottom-transition"
        >        
            <NewDocumentDialog 
                v-if="!Boolean(selection.length) && !Boolean(parent)" 
                :collection="collection" 
                @close="closeDialog" 
                @prompt="prompt"
            />

            <OpportunityDialog 
                v-if="selection.length === 1 && Boolean(parent)" 
                :document="parent.document" 
                :collection="collection" 
                @close="closeDialog" 
                @prompt="prompt"
            />
        </v-dialog>
    </div>
</template>

<script>
import Calculator from '@/components/Calculator.vue'
import NewDocumentDialog from '@/components/NewDocumentDialog.vue'
import OpportunityDialog from '@/components/OpportunityDialog.vue'
import firebase from "firebase/app"
import 'firebase/functions'

export default {
    name: 'SalesTools',
    components: {
        Calculator,
        NewDocumentDialog,
        OpportunityDialog,
    },
    computed: {
        opportunities() {
            return Boolean(this.$store.state.opportunities.items) ? 
                Object.entries(this.$store.state.opportunities.items) : []
        },
        tableData() {
            let arr = []

            if(this.collection !== null) {
                Object.entries(this.$store.state[this.collection].items).forEach(async x => {
                    //x[1].authorRecord = (x[1].author) ? await this.getUserRecord(x[1].author).data : {}

                    arr.push({
                        id: x[0],
                        ...x[1],
                        lastUpdate: this.mostRecentFirst(x[1].updates, 'time')[0]
                    })
                })
            }

            return arr
        },
    },
    data: () => ({
        users: {},
        rpp: 10,
        dialog: false,
        dial: false,
        collection: null,
        selection: [],
        parent: null,
        filter: {},
        deployed: false,
        search: {
            show: false,
            text: null,
        }
    }),
    methods: {
        headers(view) {
            let arr = []
            let headers = [
                'client',
                'author',
                'desc',
                'calcs'
            ]

            switch(view) {
                default:
                    headers.forEach(header => {
                        let target = this.$store.state[this.collection].headers.filter(item => item.value === header)[0]
                        if(Boolean(target)) arr.push(target)
                    })
            }

            return arr
        },
        load() {
            this.dialog = true
        },        
        edit() {
            this.dialog = true
        },
        del() {
            this.selection.forEach(sel => {
                this.$store.dispatch(`${this.collection}/delete`, sel.id)
            })

            this.clearSelection()
        },
        clearSelection() {
            this.selection = []
        },
        itemSelected(e) {
            this.dial = Boolean(e.value)
            this.parent = Boolean(e.value) ? { collection: this.collection, document: e.item.id } : null
        },
        getItemById(itemId) {
            return [itemId, this.$store.state.items.items[itemId]]
        },
        day(isoStr) {
            return isoStr.split('T')[0]
        },
        time(isoStr) {
            return isoStr.split('T')[1].substring(0, 5)
        },
        prompt(msg) {
            console.log(msg)
        },
        tabChange(e) {
            //console.log('tab changed')
            this.collection = e === 0 ? 'opportunities' : e === 1 ? 'quotes' : null
            this.selection = []
            if(Boolean(this.$refs.calculator)) this.$refs.calculator.initQuote()
        },
        time(isoStr) {
            return isoStr.split('T')[1].substring(0, 5)
        },
        mostRecentFirst(arr, prop) {
            return _.sortBy(arr, prop).reverse()
        },
        getUserRecord(uid) {
            let record = {}

            if(uid === this.$store.state.auth.user.id) {
                record = this.$store.state.auth.user
            }
            else {
                this.$store.state.auth.users.forEach(user => {
                    if(user.uid === uid) record = user
                })
            }
            
            return record
        },
        clearSearchTool() {
            this.search = {
                show: false,
                text: null,
            }
        },
        closeDialog() {
            this.dialog = false
        },
    },
    created() {
        this.$store.dispatch('init', ['app', 'items', 'cpp', 'vendors', 'promos', 'leasing', 'opportunities'])
    },
}

</script>